"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterItems = exports.matchItemValueToInput = exports.getSelectedSuggestionsIndex = void 0;

var getSelectedSuggestionsIndex = function getSelectedSuggestionsIndex(suggestions, selectedItem) {
  if (suggestions && selectedItem[0]) {
    return suggestions.findIndex(function (item) {
      return item.value === selectedItem[0].value;
    });
  }

  return -1;
};

exports.getSelectedSuggestionsIndex = getSelectedSuggestionsIndex;

var matchItemValueToInput = function matchItemValueToInput(item, inputValue) {
  return item && item.value.toLowerCase() === inputValue.toLocaleLowerCase();
};

exports.matchItemValueToInput = matchItemValueToInput;

var filterItems = function filterItems(inputValue, ignoreFields, item) {
  var typedValue = inputValue && inputValue.toLowerCase();

  if (typedValue && typedValue.length >= 1) {
    // eslint-disable-next-line no-unused-vars
    for (var property in item) {
      var suggestion = item[property];

      if (suggestion && (ignoreFields && ignoreFields.includes(property) || !ignoreFields || ignoreFields.length === 0) && suggestion.toLowerCase().includes(typedValue)) {
        return item;
      }
    }

    return null;
  }

  return item;
};

exports.filterItems = filterItems;